import React from "react";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import checkIcon from "assets/icons/check.svg";
import closeIcon from "assets/icons/close.svg";
import ContractTermsMain from "./ContractTermsMain";
import { loadingPage, selectEnvironment, selectPartnersData, selectUser } from "store/slices/app";
import {
  loadContractTermsValues,
  selectContractTermsData,
  submitContractTermsValues,
  updateContractTermsValues
} from "store/slices/contractTermsPage";

const dataObjectColumns = [
  {
    field: "name",
    headerName: "DATA OBJECT",
    width: 340,
    sortable: false,
    renderCell: ({ row }) => row.label
  },
  {
    field: "checked",
    headerName: "CONTRACTED",
    width: 140,
    sortable: false,
    align: "center",
    headerAlign: "center",
    renderCell: ({ row }) => {
      return row.checked === true ? (
        <img height="20px" src={checkIcon} alt="historyIcon" />
      ) : (
        <img height="20px" src={closeIcon} alt="historyIcon" />
      );
    }
  }
];

const monitoringColumns = [
  {
    field: "name",
    headerName: "MONITORING SERVICES",
    width: 340,
    sortable: false,
    renderCell: ({ row }) => row.label
  },
  {
    field: "checked",
    headerName: "CONTRACTED",
    align: "center",
    headerAlign: "center",
    width: 140,
    sortable: false,
    renderCell: ({ row }) => {
      return row.checked === true ? (
        <img height="20px" src={checkIcon} alt="historyIcon" />
      ) : (
        <img height="20px" src={closeIcon} alt="historyIcon" />
      );
    }
  }
];

const matchingColumns = [
  {
    field: "name",
    headerName: "MATCHING SERVICES",
    width: 340,
    sortable: false,
    renderCell: ({ row }) => row.label
  },
  {
    field: "checked",
    headerName: "CONTRACTED",
    align: "center",
    headerAlign: "center",
    width: 140,
    sortable: false,
    renderCell: ({ row }) => {
      return row.checked === true ? (
        <img height="20px" src={checkIcon} alt="historyIcon" />
      ) : (
        <img height="20px" src={closeIcon} alt="historyIcon" />
      );
    }
  }
];

export default function ContractTermsPage() {
  const [loading, setLoading] = useState(false);
  const [showNotification, setShowNotification] = useState({ type: "", message: "" });
  const partnersData = useSelector(selectPartnersData);
  const contractTermsdata = useSelector(selectContractTermsData);
  const environment = useSelector(selectEnvironment);
  const userData = useSelector(selectUser);
  const epId = userData.selectedPartner.id;
  const dispatch = useDispatch();

  useEffect(() => {
    setShowNotification(false);
    if (environment === "production") {
      dispatch(loadContractTermsValues(epId));
    }
  }, [dispatch, epId, environment]);

  function handleCheckboxChange(rowData) {
    return function (_, checked) {
      const changedValue = { [rowData.checkboxKey]: checked };
      dispatch(updateContractTermsValues(changedValue));
    };
  }

  function handleContractSubmit() {
    setLoading(true);
    dispatch(loadingPage(true));
    setShowNotification(false);
    setTimeout(async function () {
      try {
        await dispatch(submitContractTermsValues(contractTermsdata));
        setShowNotification({
          type: "success",
          message: "Successfully Updated"
        });
      } catch (error) {
        setShowNotification({
          type: "error",
          message: "Something went wrong. Please try after some time."
        });
      } finally {
        setLoading(false);
        dispatch(loadingPage(false));
      }
    }, 1000);
  }

  function handleAlertClose() {
    setShowNotification(false);
  }

  return (
    <ContractTermsMain
      dataObjectColumns={dataObjectColumns}
      monitoringColumns={monitoringColumns}
      matchingColumns={matchingColumns}
      showNotification={showNotification}
      submitInProgress={loading}
      isSuperUser={userData.isSuperUser}
      userRole={userData.role}
      partners={partnersData.partners}
      values={contractTermsdata}
      onAlertClose={handleAlertClose}
      onSubmit={handleContractSubmit}
      onCheckboxChange={handleCheckboxChange}
    />
  );
}
